import React, { useEffect, useState } from "react";
import { api, fmtMoney } from "../lib/api";
import { Trophy } from "lucide-react";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leaderboard").then(r => setRows(r.data || [])); }, []);

  if (!rows.length) {
    return (
      <div className="core-card p-7" data-testid="leaderboard-empty">
        <div className="overline">Leaderboard</div>
        <h3 className="font-heading text-2xl mt-1 mb-3">Top producers</h3>
        <div className="text-sm text-[#050303]/55">No closed deals yet — the first to close shows up here.</div>
      </div>
    );
  }
  return (
    <div className="core-card p-7" data-testid="leaderboard">
      <div className="flex items-center gap-2">
        <Trophy size={16} className="text-[#bf858e]" strokeWidth={1.5} />
        <div className="overline">Leaderboard</div>
      </div>
      <h3 className="font-heading text-2xl mt-1 mb-5">Top producers · YTD</h3>
      <div className="space-y-3">
        {rows.map((r, i) => (
          <div key={r.agent_id} className="flex items-center justify-between border-b border-[#d1cece] last:border-0 pb-3" data-testid={`leaderboard-row-${i}`}>
            <div className="flex items-center gap-3">
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${i === 0 ? "bg-[#050303] text-white" : "bg-[#e1b7c1]/50 text-[#050303]"}`}>{i + 1}</span>
              <div>
                <div className="font-semibold text-sm">{r.name}</div>
                <div className="text-xs text-[#050303]/55">{r.deals} closed · {fmtMoney(r.volume)} volume</div>
              </div>
            </div>
            <span className="font-heading text-xl">{fmtMoney(r.gci)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
